'use client';
import { useEffect, useState } from 'react';
import * as CookieConsent from 'vanilla-cookieconsent';

function AnalyticsPreconnect() {
    const [analyticsAccepted, setAnalyticsAccepted] = useState(false);

    useEffect(() => {
        // Check if analytics cookies are accepted
        const checkConsent = () => {
            const cookie = CookieConsent.getCookie();
            const categories = cookie?.categories || [];
            const accepted = categories.includes('analytics');
            setAnalyticsAccepted(accepted);
        };

        // Check on mount with a slight delay to ensure library is initialized
        const timer = setTimeout(checkConsent, 100);

        // Listen for consent events
        window.addEventListener('cc:onConsent', checkConsent);
        window.addEventListener('cc:onChange', checkConsent);
        
        return () => {
            clearTimeout(timer);
            window.removeEventListener('cc:onConsent', checkConsent);
            window.removeEventListener('cc:onChange', checkConsent);
        };
    }, []);

    // Only add preconnect links if analytics consent is given
    if (!analyticsAccepted) {
        return null;
    }

    return (
        <>
            <link rel="preconnect" href="https://www.google-analytics.com" />
            <link rel="preconnect" href="https://googleads.g.doubleclick.net" />
        </>
    );
}

export default AnalyticsPreconnect;
